import React from "react"
import tw from "twin.macro"
import { ComponentProps } from "../../types/components"

const StyledMain = tw.main`
  pt-[86px] md:pt-[122px] flex-1
`

export const Main = ({ children }: ComponentProps) => {
  return <StyledMain id="content-main">{children}</StyledMain>
}
